const formatTimeLabel = (seconds: number) => {
    if (seconds === 86400) {
        return '12:00am';
    }
    const totalMinutes = Math.floor(seconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const period = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 === 0 ? 12 : hours % 12;
    return `${hour12}:${String(minutes).padStart(2, '0')}${period}`;
};

export default formatTimeLabel;
